import {useForm, FormProvider} from 'react-hook-form'
import {zodResolver} from '@hookform/resolvers/zod'
import {CompanyInfoFormValidationSchema} from '@/features/company-info/types'
import {GeneralInfoSection} from '@/features/company-info/components/general-info-section/GeneralInfoSection'
import {StructureInfoSection} from '@/features/company-info/components/structure-info-section/StructureInfoSection'
import {BankInfoSection} from '@/features/company-info/components/bank-info-section/BankInfoSection'
import {useEffect} from 'react'

interface CompanyInfoFormProps {
    initialData?: CompanyInfoFormValidationSchema
    onSubmit: (data: CompanyInfoFormValidationSchema) => void
}

export const CompanyInfoForm = ({initialData, onSubmit}: CompanyInfoFormProps) => {
    const methods = useForm<CompanyInfoFormValidationSchema>({
        resolver: zodResolver(CompanyInfoFormValidationSchema),
        defaultValues: initialData || {}
    })

    // Update form when initialData changes
    useEffect(() => {
        if (initialData) {
            Object.entries(initialData).forEach(([key, value]) => {
                methods.setValue(key as keyof CompanyInfoFormValidationSchema, value as string | boolean)
            })
        }
    }, [initialData, methods])

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
                <GeneralInfoSection />
                <StructureInfoSection />
                <BankInfoSection />
            </form>
        </FormProvider>
    )
}
